const rankingItems = [
  { rank: 1, title: '顶流艺人深夜密会神秘女子', tag: '恋情实锤', heat: '🔥 1280万', change: 'up' },
  { rank: 2, title: '知名网红带货翻车遭集体解约', tag: '网红翻车', heat: '🔥 980万', change: 'up' },
  { rank: 3, title: '综艺录制现场选手摔麦离场', tag: '综艺内幕', heat: '🔥 850万', change: 'new' },
  { rank: 4, title: '金童玉女被曝分居财产分割中', tag: '豪门恩怨', heat: '🔥 760万', change: 'up' },
  { rank: 5, title: '多位艺人被约谈税务整顿升级', tag: '税务风波', heat: '690万', change: 'down' },
  { rank: 6, title: '制片人暗指流量明星耍大牌', tag: '片场秘闻', heat: '580万', change: 'up' },
  { rank: 7, title: '海外留学生爆料国内娱乐圈内幕', tag: '海外爆料', heat: '470万', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            吃瓜热度榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            实时更新的51吃瓜黑料话题讨论热度排行
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="rounded-xl overflow-hidden border border-background-200/50 bg-background-50">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href="#media"
                className={`flex items-center gap-4 p-4 md:p-5 hover:bg-background-100 transition-colors duration-200 cursor-pointer ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center text-sm font-heading ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-secondary-300 text-foreground-900'
                    : item.rank === 3
                    ? 'bg-secondary-200 text-foreground-700'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">
                      {item.title}
                    </h3>
                    <span className={`flex-shrink-0 text-xs ${
                      item.change === 'up' ? 'text-primary-500' :
                      item.change === 'new' ? 'text-accent-600' :
                      'text-secondary-500'
                    }`}>
                      {item.change === 'up' && <i className="ri-arrow-up-fill"></i>}
                      {item.change === 'down' && <i className="ri-arrow-down-fill"></i>}
                      {item.change === 'new' && <i className="ri-sparkling-fill"></i>}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                      {item.tag}
                    </span>
                    <span>{item.heat}</span>
                  </div>
                </div>

                <div className="flex-shrink-0 text-foreground-400">
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}